import React from 'react';
import { checkPasswordRules } from '../../utils/passwordPolicy';

// UX-005: the full password rules, shown up front on every screen where a password is set, with each rule ticking
// as the user types. The rules come from utils/passwordPolicy.js (identical to the server's policy file).
export default function PasswordRules({ password }) {
  const rules = checkPasswordRules(password);
  return (
    <div role="group" aria-label="Password rules" style={{ marginTop: '0.4rem', fontSize: '0.8rem' }}>
      <div style={{ color: 'var(--text-secondary)', marginBottom: '0.2rem' }}>Your password must have:</div>
      <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
        {rules.map(r => (
          <li key={r.id} data-rule={r.id} data-met={r.met ? 'true' : 'false'} style={{ color: r.met ? '#15803d' : 'var(--text-secondary)' }}>
            <span aria-hidden="true" style={{ display: 'inline-block', width: '1.25rem', fontWeight: 700 }}>{r.met ? '✓' : '○'}</span>
            {r.label}
            <span style={{ position: 'absolute', left: '-9999px' }}>{r.met ? ' (met)' : ' (not met yet)'}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
